import React, { memo } from 'react';
import Skeleton from './Skeleton';

const DashboardSkeleton = memo(function DashboardSkeleton({ style = {} }) {
  return (
    <div style={{ padding: '24px 20px', background: 'var(--cream, #FAF8F3)', minHeight: '100vh', ...style }} aria-busy="true">
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <Skeleton variant="text" width={240} height={32} style={{ marginBottom: 8 }} />
        <Skeleton variant="text" width={340} height={14} />
      </div>

      {/* 4 Stat Cards */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 16,
          marginBottom: 24,
        }}
      >
        {Array.from({ length: 4 }).map((_, idx) => (
          <div
            key={idx}
            style={{
              padding: '20px 24px',
              borderRadius: 14,
              background: '#FFFFFF',
              border: '1.5px solid var(--border, #E5E7EB)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <div>
              <Skeleton variant="text" width={90} height={12} style={{ marginBottom: 10 }} />
              <Skeleton variant="text" width={110} height={30} />
            </div>
            <Skeleton variant="circular" width={42} height={42} />
          </div>
        ))}
      </div>

      {/* Recent Activity / Demands list section */}
      <div style={{ marginBottom: 28 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <Skeleton variant="text" width={180} height={22} />
          <Skeleton variant="rectangular" width={90} height={28} borderRadius={8} />
        </div>

        {Array.from({ length: 3 }).map((_, idx) => (
          <div
            key={idx}
            style={{
              padding: 16,
              borderRadius: 12,
              background: '#FFFFFF',
              border: '1.5px solid var(--border, #E5E7EB)',
              marginBottom: 10,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ flex: 1, paddingRight: 16 }}>
              <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <Skeleton variant="rectangular" width={60} height={20} borderRadius={12} />
                <Skeleton variant="rectangular" width={75} height={20} borderRadius={12} />
              </div>
              <Skeleton variant="text" width="75%" height={16} style={{ marginBottom: 6 }} />
              <Skeleton variant="text" width="45%" height={12} />
            </div>
            <Skeleton variant="rectangular" width={100} height={36} borderRadius={9} />
          </div>
        ))}
      </div>

      {/* Analytics / Charts Row */}
      <div className="grid-1-2" style={{ gap: 20 }}>
        <div style={{ background: '#FFFFFF', borderRadius: 14, padding: 20, border: '1.5px solid var(--border, #E5E7EB)' }}>
          <Skeleton variant="text" width={160} height={20} style={{ marginBottom: 16 }} />
          <Skeleton variant="rectangular" width="100%" height={180} borderRadius={8} />
        </div>
        <div style={{ background: '#FFFFFF', borderRadius: 14, padding: 20, border: '1.5px solid var(--border, #E5E7EB)' }}>
          <Skeleton variant="text" width={160} height={20} style={{ marginBottom: 16 }} />
          <Skeleton variant="rectangular" width="100%" height={180} borderRadius={8} />
        </div>
      </div>
    </div>
  );
});

export default DashboardSkeleton;
